import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {CardPayment} from "../../interface/card-payment";
import {Response} from "../../interface/response";
import {Carousel} from "../../interface/carousel";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient) { }


  getInfoCard(cardInfo: CardPayment){
    return this.http.post<Response>(`${environment.baseUrl}/service/webapi/subscription/search`, cardInfo, { observe: 'response' });
  }

  unsubscribe(tokenHash: string | null | undefined){
   return this.http.post<Response>(`${environment.baseUrl}/service/webapi/subscription/unsubscribe/${tokenHash}`,null)
  }

  checkUnsubscription(tokenHash: string | null | undefined){
    return this.http.get<Response>((`${environment.baseUrl}/service/webapi/subscription/checkunsubscription/${tokenHash}`), { observe: 'response' })
  }
  getCarouselInfo(carouselThanks: string | null | undefined){
    return this.http.get<Carousel[]>((`${environment.baseUrl}/service/webapi/carouselthanks/${carouselThanks}`))
  }
}

